import { usePartnerSearchContext } from '../../../../../../ContextProvider/Partner/Search';
import SearchByLocationForm from './SearchByLocationForm';
import FilterByNeedForm from './FilterByNeedForm';
import SearchByCombinedCriteriaForm from "./SearchByCombinedCriteriaForm";

export default function TabbedForms({className}) {
  const {
    isFilterByNeedFormSelected,
    isSearchByLocationFormSelected,
  } = usePartnerSearchContext();

  if (isFilterByNeedFormSelected()) {
    return <FilterByNeedForm className={className}/>
  }
  else {
    if (isSearchByLocationFormSelected()) {
      return <SearchByLocationForm className={className}/>
    }
    else {
      return <SearchByCombinedCriteriaForm className={className}/>
    }
  }
}
